import { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form, Modal, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'

import API from '../../api/api'
import Actions from '../../redux/actions'

export default function AccountInfo(props) {

    const [showModal, setShowModal] = useState(false)
    const user = useSelector(state => state.user)
    const [editMode, setEditMode] = useState(false)
    const [fName, setFName] = useState('')
    const [lName, setLName] = useState('')

    const [pwErr, setPwErr] = useState('')
    const [showPasswordChange, setShowPasswordChange] = useState(false)

    const [oldPW, setOldPW] = useState('')
    const [newPW, setNewPw] = useState('')
    const [confirmPW, setConfirmPW] = useState('')


    const dispatch = useDispatch()
    useEffect(() => {
        setFName(user?.fName)
        setLName(user?.lName)
    }, [user])


    const save = async () => {
        const updatedUser = await API.changeName(fName, lName)
        dispatch(Actions.setUser(updatedUser))
        dispatch(Actions.setToast('Name Updated ✅', 'Your name has been updated.'))
    }


    const _submitPassChange = async (e) => {
        e.preventDefault()
        setPwErr('')
        if (oldPW === newPW) {
            setPwErr('Old and New Passwords Cannot Be the Same')
            clearPW()
            return
        }
        if (newPW.length < 8) {
            setPwErr('New password must be at least 8 characters long')
            clearPW()
            return
        }

        if (newPW !== confirmPW) {
            setPwErr('Passwords do not match')

            return
        }

        const res = await API.changePW(oldPW, newPW)
       
        if (res.errMsg) {
            setPwErr(res.errMsg)
        } else {
            setShowPasswordChange(false)
            // dispatch(AlertActions.showAlert('Your Password Has Successfully Been Updated', false))
            clearPW()
        }

    }

    const clearPW = () => {
        setNewPw('')
        setOldPW('')
        setConfirmPW('')
    }
    return (
        <>

            <Row className='justify-content-between pb-2 underline mb-4'>
                <Col md={3} className='text-start'>
                    <h2>Account</h2>
                </Col>
                <Col md={6} className='text-end'>
                    {!editMode && <Button variant='primary text-white' onClick={() => setEditMode(true)}>Edit</Button>}
                    {editMode && <Button variant='link noDecoration' onClick={() => setEditMode(false)}>Cancel</Button>}
                    {editMode && <Button disabled={fName === '' || lName === ''} variant='primary text-white' onClick={() => { setEditMode(false); save() }}>Save</Button>}
                </Col>
            </Row>

            <Row className='p-1'>
                <Col md={3} className='text-start weight-bold'><p>Email</p></Col>
                <Col md={6}>
                    <p>{user?.email}</p>
                    {editMode && <p><small>Email <a href='mailto:support@scamwall.io'>support@scamwall.io</a> If you need your email changed</small></p>}
                </Col>
            </Row>
            <Row className='p-1'>
                <Col md={3} className='text-start weight-bold'><p>Number</p></Col>
                <Col md={6}>
                    <p>{user?.phone}</p>
                    {editMode && <p><small>Email <a href='mailto:support@scamwall.io'>support@scamwall.io</a> If you need your number changed</small></p>}
                </Col>
            </Row>
            <Row className='p-1'>
                <Col md={3} className='text-start weight-bold'><p>Name</p></Col>
                <Col md={6}>
                    {!editMode && <p>{user?.fName} {user?.lName}</p>}
                    {editMode && <Row>
                        <Col>
                            <Form.Control type='text' value={fName} onChange={e => setFName(e.target.value)} placeholder='First Name' />

                        </Col>
                        <Col>
                            <Form.Control type='text' placeholder='Last Name' value={lName} onChange={e => setLName(e.target.value)} />

                        </Col>
                    </Row>}

                </Col>
            </Row>
            <Row className='p-1'>
                <Col md={3} className='text-start weight-bold my-auto'><p>Password</p></Col>
                <Col md={3} className='my-auto'>
                    <p style={{ fontSize: '2rem' }}>&#183;&#183;&#183;&#183;&#183;&#183;&#183;&#183;&#183;</p>
                    {editMode && <Button variant='primary text-white' onClick={() => setShowPasswordChange(true)}>Change Password</Button>}
                </Col>
            </Row>
            <Button variant='link noDecoration ps-0 ms-0' onClick={() => setShowModal(true)}>Log Out</Button>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton >
                    <Modal.Title>Are You Sure?</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>Are You Sure You Want to Logout?.</p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="primary text-white" onClick={() => setShowModal(false)}>No, Stay Logged In</Button>
                    <Button variant="link noDecoration" onClick={() => API.logout()}>Yes, Log Me Out</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showPasswordChange} onHide={() => setShowPasswordChange(false)}>
                <Modal.Header closeButton >
                    <Modal.Title>Change Password</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <form onSubmit={_submitPassChange}>


                        <Form.Group >
                            <Form.Label>Old Password</Form.Label>
                            <Form.Control type='password' required placeholder='Old Password' value={oldPW} onChange={e => setOldPW(e.target.value)} />

                        </Form.Group>
                        <hr className='m-3' />
                        <Form.Group >
                            <Form.Label>New Password</Form.Label>
                            <Form.Control type='password' required placeholder='New Password' value={newPW} onChange={e => setNewPw(e.target.value)} />
                        </Form.Group>
                        <Form.Group className='mt-3' >
                            <Form.Label>Confirm New Password</Form.Label>
                            <Form.Control type='password' required placeholder='Confirm Password' value={confirmPW} onChange={e => setConfirmPW(e.target.value)} />

                        </Form.Group>
                        {pwErr !== '' && <Alert variant='danger m-2'>{pwErr}</Alert>}
                        <div className='text-center'>
                            <Button variant='primary text-white m-4' type='submit'>Change Password</Button>

                        </div>
                    </form>
                </Modal.Body>

            </Modal>

        </>
    )
}